import { ReactNode } from 'react';
import { MdOutlineAdd, MdOutlineHorizontalRule } from 'react-icons/md';
import { IconButton } from '@ds';

type NumberPickerProps = {
  value: number;
  minValue?: number;
  maxValue?: number;
  renderValue?: (value: number) => ReactNode;
  onChange: (value: number) => void;
  isDisabled?: boolean;
};

export const NumberPicker = ({ value, minValue, maxValue, renderValue, onChange, isDisabled }: NumberPickerProps) => {
  const handleMinusAction = () => {
    const newValue = value - 1;
    if (minValue && newValue < minValue) return;

    onChange(newValue);
  };

  const handlePlusAction = () => {
    const newValue = value + 1;
    if (maxValue && newValue > maxValue) return;

    onChange(newValue);
  };

  return (
    <div className="w-full flex gap-2 justify-between items-center rounded-lg bg-base-90 p-1">
      <IconButton
        isDisabled={isDisabled || (typeof minValue === 'number' ? value <= minValue : false)}
        variant="light"
        size="xs"
        startContent={<MdOutlineHorizontalRule size={20} />}
        onPress={handleMinusAction}
      />
      {renderValue ? renderValue(value) : <span className="text-m-r text-base-5">{value}</span>}
      <IconButton
        isDisabled={isDisabled || (maxValue ? value >= maxValue : false)}
        variant="light"
        size="xs"
        startContent={<MdOutlineAdd size={20} />}
        onPress={handlePlusAction}
      />
    </div>
  );
};
